import React, { useState, useEffect } from "react";
import "./dentalOffer.css";

const offerImages = [
  // Smiling woman with perfect teeth
  "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc21pbGV8ZW58MHx8fHwxNzQyNTAwMTE4fDA&auto=format&fit=crop&w=600&q=80",
  
  // Dental office with modern equipment
  "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwb2ZmaWNlfGVufDB8fHx8MTc0MjQ4MTc5OXww&auto=format&fit=crop&w=600&q=80",
  
  // Girl with toothbrush
  "https://images.unsplash.com/photo-1609840113564-ab4aba4956c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNzE4NDU3Mjk5fA&auto=format&fit=crop&w=600&q=80",
  
  // Dental tools closeup
  "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsfGVufDB8fHx8MTcxODMwMDI2OXww&auto=format&fit=crop&w=600&q=80",
  
  // Woman with beautiful smile
  "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNzE4NzYwNTI5fA&auto=format&fit=crop&w=600&q=80",
  
  // Dental implants/dentures
  "https://images.unsplash.com/photo-1473232117216-c950d4ef2e14?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNzE4NjQ0Njc5fA&auto=format&fit=crop&w=600&q=80",
  
  // Professional dentist equipment
  "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdHxlbnwwfHx8fDE3NDI0NDc1MjR8MA&auto=format&fit=crop&w=600&q=80",
  
  // Dental chair in modern clinic
  "https://images.unsplash.com/photo-1495112612632-9c7423865423?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNzE4Njk0MDUyfA&auto=format&fit=crop&w=600&q=80",
  
  // Dental tools by window
  "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
];



const DentalOffer = () => {
  const [showOffer, setShowOffer] = useState(false);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOffer(true);
      document.body.style.overflow = "hidden";
    }, 3000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto";
    };
  }, []);

  // Carousel effect for images
  useEffect(() => {
    if (!showOffer) return;
    const imgTimer = setInterval(() => {
      setActiveImg((prev) => (prev + 1) % offerImages.length);
    }, 1800);
    return () => clearInterval(imgTimer);
  }, [showOffer]);

  const handleClose = () => {
    setShowOffer(false);
    document.body.style.overflow = "auto";
  };

  const handleBookNow = () => {
    // Direct to dental offer URL
    window.open("https://www.dentalplans.com/lp/save-on-dental-care", "_blank");
    setShowOffer(false);
    document.body.style.overflow = "auto";
  };

  if (!showOffer) return null;

  return (
    <div className="offer-overlay" id="dental-offer-overlay">
      <div className="offer-popup offer-animated">
        <button className="offer-close" onClick={handleClose}>
          ×
        </button>
        <div className="offer-img-carousel">
          {offerImages.map((img, idx) => (
            <img
              key={img}
              src={img}
              alt="Dental Offer"
              className={`offer-carousel-img${activeImg === idx ? " active" : ""}`}
              style={{ display: activeImg === idx ? "block" : "none" }}
            />
          ))}
          <div className="offer-blink-badge">🔥 Limited Time Offer 🔥</div>
        </div>
        <div className="offer-content offer-content-animated">
          <h2 className="offer-title">Special Dental Package</h2>
          <div className="offer-treatment">Scaling &amp; Polishing</div>
          <div className="offer-price">
            <span className="offer-price-currency">₹</span>
            <span className="offer-price-amount">399</span>
            <span className="offer-price-only">only</span>
          </div>
          <div className="offer-benefits">
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Professional Teeth Cleaning</span>
            </div>
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Removes Plaque &amp; Stains</span>
            </div>
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Healthier Gums</span>
            </div>
          </div>
          <button className="offer-button offer-blink-btn" onClick={handleBookNow}>
            Book Your Consultation
          </button>
        </div>
      </div>
    </div>
  );
};

export default DentalOffer;
